require("./retailLoanPromotionInfo.scss");

// @vendor
const React = require("react");
const PropTypes = require("prop-types");
// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

class RetailLoanPromotionInfo extends React.Component {
    render() {
        const { content, endDate, cmsId } = this.props;
        const isVariantB = cmsId === 'Estrena_Movil_B';
        const componentClass = `retail-loan-promotion-info${isVariantB ? ' retail-loan-promotion-info--variant-b' : ''}`;

        return (
            <div className={componentClass}>
                <div className="retail-loan-promotion-info__date">
                    <i className="icon icon-calendario retail-loan-promotion-info__date-icon" />
                    <span className="retail-loan-promotion-info__date-text">
                        {endDate}
                    </span>
                </div>

                <div className="retail-loan-promotion-info__content">
                    <HTMLSafeInjector message={content} />
                </div>
            </div>
        );
    }
}

RetailLoanPromotionInfo.propTypes = {
    content: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    cmsId: PropTypes.string.isRequired
};

export { RetailLoanPromotionInfo };
